import { Box, BoxProps } from "@mui/material";

import { layoutClasses } from "../settings";

export const LayoutContent = ({ children, sx, ...other }: BoxProps) => {
  return (
    <Box
      className={layoutClasses.main}
      component="main"
      sx={{
        display: "flex",
        flex: "1 1 auto",
        flexDirection: "column",
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
};
